module.exports = "/images/sky.png?1c65eb2a7df3f7032870f64cb5e4cacc";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/banner/sky.png
// module id = J7D5
// module chunks = 0